import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  wrapper: {
    height: '100%',
    background: '#fff',
    borderLeft: '1px solid rgba(0, 0, 0, 0.2)',
  },
  profile: {
    borderBottom: '0.5px solid rgb(204, 204, 204)',
    '& div': {
      '&::first-child': {
        fontWeight: 600,
      },
    },
  },
  profile_info: {
    '& div': {
      '&:first-child': {
        fontWeight: 600,
        letterSpacing: '0.5px',
        color: '#4a4a4a',
      },
    },
  },
  profile_link: {
    color: '#4a4a4a',
    outlined: 'none',
    '&:hover': {
      color: '#000',
    },
  },
  title: {
    fontWeight: 600,
    color: '#4a4a4a',
    minWidth: '75px',
  },
  link: {
    lineHeight: '1.2',
    color: 'rgba(18, 117, 216, 1)',
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  date: {
    opacity: 0.8,
    fontSize: '13px',
  },
  icon_container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end'
  },
  createOrderButton: {
    padding: '3px 8px', 
    fontSize: '0.7rem', 
    color: 'rgba(18, 117, 216, 1)',
    border: '1px solid rgba(18, 117, 216, 1)'
  }
}));
